// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { Component } from 'react';
import { Glyphicon } from 'react-bootstrap';
import Select from 'react-select';

class State {
  data = [];
  airports = [];
  selectValue = '';
  currentAirport = {};
  open = false;
}

export default class ElementSelector extends Component {
  state = new State();

  render() {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { options, value, placeholder, onChange } = this.props;
    return (
      <Select
        placeholder={placeholder}
        isClearable
        components={{
          DropdownIndicator: () => (
            <Glyphicon
              style={{ color: '#c4c4c4', paddingRight: '10px' }}
              glyph='chevron-down'
            />
          ),
          IndicatorSeparator: () => null,
          ClearIndicator: () => null,
        }}
        styles={{
          menu: styles => ({ ...styles, zIndex: 3000 }),
          control: styles => ({
            ...styles,
            '&:focus': {
              borderColor: '#4496d8',
              boxShadow: 'none',
              outline: '0',
            },
          }),
        }}
        isMulti
        openMenuOnClick
        value={value}
        onChange={onChange}
        options={options}
      />
    );
  }
}
